import React from 'react'
import Layout from '../layout/Layout'
import CaseStudyRoot from '../views/CaseStudy/CaseStudyRoot'
import { SEO } from '../components'
import { graphql } from 'gatsby'

export default ({ data }) => {
  return (
    <Layout>
      <SEO
        metaDescription={data.contentfulCaseStudy.description.description}
        title={data.contentfulCaseStudy.title}
        slug={data.contentfulCaseStudy.slug}
      />
      <CaseStudyRoot data={data.contentfulCaseStudy} />
    </Layout>
  )
}

export const query = graphql`
  query($slug: String!) {
    contentfulCaseStudy(slug: { eq: $slug }) {
      id
      title
      slug
      order
      theme
      secondaryTheme
      gradientTheme
      quote
      services
      showcaseImage {
        fluid {
          aspectRatio
          src
          srcSet
          sizes
        }
      }
      headerImage {
        fluid(maxWidth: 900) {
          aspectRatio
          src
          srcSet
          sizes
        }
      }
      x1grid {
        fluid(maxWidth: 1920) {
          aspectRatio
          src
          srcSet
          sizes
        }
        fixed(width: 1920) {
          aspectRatio
          width
          height
          src
          srcSet
        }
      }
      fullscreenImage {
        fluid(maxWidth: 1920) {
          aspectRatio
          src
          srcSet
          sizes
        }
      }
      description {
        description
      }
      createdAt
      playStoreLink
      appleStoreLink
      websiteLink
    }
  }
`
